import './VideoListScreen.css';

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import db from '../Core/firebaseCore';
import Card from './Components/Card';
import NoRecordFound from './Components/NoRecordFound';

function VideoListScreen() {
    const { category } = useParams();
    const [categoryName, setCategoryName] = useState(null);
    const [videos, setVideos] = useState([]);
    useEffect(async () => {
        if (category) {
            const _category = await db.collection('categories').doc(category).get();
            console.log(_category.data())
            setCategoryName(_category.data().name);
            const _snapshot = await db.collection('videos')
                .where('categories', 'array-contains', category)
                .where('active', '==', true)
                .orderBy('createdOn', 'asc').get();
            if (_snapshot.docs.length > 0) {
                let videos_local = _snapshot.docs.map((doc) => {
                    let _data = doc.data();
                    _data.id = doc.id;
                    return _data;
                });
                setVideos(videos_local);
            }
            else {
                setVideos([]);
            }
        }
    }, [category]);
    return (
        <div className="video-list container">
            <h4 className="title">{categoryName} Videos</h4>
            {videos.length > 0 ? (<Card videos={videos} />) : (<NoRecordFound />)}
        </div>
    )
}

export default VideoListScreen
